// extracted by mini-css-extract-plugin
export default {"container":"FloatButton_container__cOJnl","label":"FloatButton_label__ZFTEM","arrow":"FloatButton_arrow__sUsp7"};